
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[projectId]/activity",
      function () {
        return require("private-next-pages/[projectId]/activity.tsx");
      }
    ]);
  